/* drip theme · behaviour. No dependencies. */
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var cfg = window.drip || {};
  var SHOP = cfg.shopUrl || '/';
  var ARR_L = '<svg class="i" viewBox="0 0 24 24"><path d="M15 6l-6 6 6 6"/></svg>';
  var ARR_R = '<svg class="i" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>';

  /* ---------- helpers ---------- */
  function money(cents) {
    var f = (cfg.money && cfg.money.format) || '${{amount}}';
    var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return f.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/, n).replace(/<[^>]+>/g, '');
  }
  function dollars(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function toast(t) { var el = $('.toast'); if (!el) return; el.textContent = t; el.classList.add('on'); clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('on'); }, 1800); }

  /* ---------- Klaviyo (client endpoints, public site key only) ----------
     /client/* takes the public company_id that ships in Klaviyo's own onsite snippet, so
     nothing secret is exposed. Two calls per signup on purpose: the subscription records
     consent and list membership, the event carries the detail (which scent) and is what a
     flow should actually trigger on - a profile property would be overwritten the next
     time the same person asked about a different scent. */
  var KL = cfg.klaviyo || {};
  function klFetch(path, body) {
    if (!KL.key) return Promise.reject(new Error('klaviyo not configured'));
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw r; return r; });
  }
  function klSubscribe(email, listId, source) {
    return klFetch('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'drip storefront',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    });
  }
  function klEvent(email, metric, props) {
    return klFetch('events', {
      data: {
        type: 'event',
        attributes: {
          properties: props || {},
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    });
  }

  /* ---------- drawers ---------- */
  var ov = $('[data-ov]'), nav = $('#mnav'), cart = $('#cart');
  function closeAll() { [nav, cart].forEach(function (d) { d && d.classList.remove('on'); }); ov && ov.classList.remove('on'); document.body.style.overflow = ''; }
  function open(d) { if (!d) return; closeAll(); d.classList.add('on'); ov && ov.classList.add('on'); document.body.style.overflow = 'hidden'; }
  $$('[data-open="nav"]').forEach(function (b) { b.addEventListener('click', function () { open(nav); }); });
  $$('[data-open="cart"]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(function () { open(cart); }); }); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
  ov && ov.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- ajax cart (slide cart is the only cart) ---------- */
  var FREE = (cfg.freeShipping || 50) * 100;
  var UPS = cfg.upsell || [];
  var upsTab = 0;
  function compareFor(variantId) { for (var i = 0; i < UPS.length; i++) if (UPS[i].id === variantId) return UPS[i].compare; return 0; }

  function renderCart(c) {
    $$('[data-cart-count]').forEach(function (x) { x.textContent = c.item_count; });
    var list = $('#cartlist'); if (!list) return;
    var was = 0;
    if (!c.items.length) {
      list.innerHTML = '<div class="empty">Your cart is empty.<br><a href="' + SHOP + '" class="cta" style="margin-top:18px;min-height:48px">Shop drip</a></div>';
    } else {
      list.innerHTML = c.items.map(function (i) {
        var cmp = compareFor(i.variant_id) || i.original_price; if (cmp < i.final_price) cmp = i.final_price;
        was += cmp * i.quantity;
        var props = Object.keys(i.properties || {}).filter(function (k) { return k.charAt(0) !== '_'; }).map(function (k) { return esc(k) + ': ' + esc(i.properties[k]); }).join(' · ');
        var scent = i.product_title.replace(' Body Butter', '');
        return '<div class="line"><div class="ph">' + (i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?.*)?$/, '_160x160$1$2') + '" alt="">' : '') + '</div>' +
          '<div class="lt"><b>' + esc(i.product_title) + (i.selling_plan_allocation ? ' · Subscription' : '') + '</b><small>' + (props || 'Scent: ' + esc(scent)) + '</small>' +
          '<div class="pr' + (i.final_price === 0 ? ' free' : '') + '">' + (cmp > i.final_price ? '<s>' + money(cmp) + '</s>' : '') + (i.final_price === 0 ? 'FREE' : money(i.final_price)) + '</div></div>' +
          '<div class="qty"><button type="button" data-q="-1" data-key="' + i.key + '" aria-label="Decrease quantity">−</button><span>' + i.quantity + '</span><button type="button" data-q="1" data-key="' + i.key + '" aria-label="Increase quantity">+</button></div></div>';
      }).join('');
      $$('#cartlist [data-q]').forEach(function (b) {
        b.addEventListener('click', function () {
          var line = c.items.filter(function (x) { return x.key === b.getAttribute('data-key'); })[0]; if (!line) return;
          b.disabled = true; change(line.key, Math.max(0, line.quantity + (+b.getAttribute('data-q'))));
        });
      });
    }
    var tot = $('#carttot'); if (tot) tot.textContent = money(c.total_price);
    var cnt = $('#cartcount-l'); if (cnt) cnt.textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items');
    var saving = was - c.total_price;
    var comp = $('#cartcomp'); if (comp) comp.textContent = saving > 0 ? money(was) : '';
    var sv = $('#cartsave'); if (sv) { sv.hidden = !(saving > 0); sv.textContent = money(saving) + ' OFF'; }
    var pct = Math.min(100, c.total_price / FREE * 100); var bar = $('#cartprog b'); if (bar) bar.style.width = pct + '%';
    var pt = $('#cartprogtxt'); if (pt) pt.textContent = c.total_price >= FREE ? 'You’ve unlocked FREE US shipping' : 'Spend ' + money(FREE - c.total_price) + ' more and get FREE shipping';
    var co = $('#checkout'); if (co) co.classList.toggle('busy', !c.items.length);
    renderUps(c);
  }
  function renderUps(c) {
    var box = $('[data-ups]'); if (!box || !UPS.length) return;
    var inCart = {}; c.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var tabs = [
      { n: 'Recommended', f: function (u) { return !inCart[u.pid]; } },
      { n: 'Best sellers', f: function () { return true; } }
    ];
    var t = $('[data-ups-tabs]', box), row = $('[data-ups-row]', box), dots = $('[data-ups-dots]', box);
    t.innerHTML = tabs.map(function (x, i) { return '<button type="button" class="' + (i === upsTab ? 'on' : '') + '" data-t="' + i + '">' + x.n + '</button>'; }).join('');
    $$('button', t).forEach(function (b) { b.addEventListener('click', function () { upsTab = +b.getAttribute('data-t'); renderUps(c); }); });
    var items = UPS.filter(tabs[upsTab].f); if (!items.length) items = UPS;
    row.innerHTML = items.map(function (u) {
      return '<div class="upc"><div class="ph"><img src="' + u.img + '" alt=""></div><div class="ut"><b>' + esc(u.title) + '</b><small>' + (u.insp ? 'Inspired by ' + esc(u.insp) : 'Whipped body butter') + '</small><div class="pr">' + (u.compare > u.price ? '<s>' + money(u.compare) + '</s>' : '') + money(u.price) + '</div></div>' +
        (u.st === 'pre' ? '<a class="cta add pre" href="' + u.url + '">Pre-order</a></div>' :
        '<button type="button" class="cta add" data-add="' + u.id + '"' + (u.avail && u.st !== 'out' ? '' : ' disabled') + '>' + (u.avail && u.st !== 'out' ? 'Add +' : 'Sold out') + '</button></div>');
    }).join('');
    $$('[data-add]', row).forEach(function (b) {
      b.addEventListener('click', function () {
        b.classList.add('busy');
        add({ items: [{ id: +b.getAttribute('data-add'), quantity: 1 }] }).then(function () { toast('Added to cart'); return refreshCart(); })
          .catch(function () { b.classList.remove('busy'); toast('Could not add to cart'); });
      });
    });
    dots.innerHTML = items.map(function (_, i) { return '<i class="' + (i === 0 ? 'on' : '') + '"></i>'; }).join('');
    row.onscroll = function () { var w = row.firstElementChild ? row.firstElementChild.offsetWidth + 10 : 1; var k = Math.round(row.scrollLeft / w); $$('i', dots).forEach(function (x, j) { x.classList.toggle('on', j === k); }); };
    box.hidden = false;
  }
  function refreshCart() { return fetch(cfg.routes.cartJs, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {}); }
  function change(key, qty) { return fetch(cfg.routes.cartChange + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }).then(renderCart); }
  function add(payload) { return fetch(cfg.routes.cartAdd + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) }).then(function (r) { if (!r.ok) throw r; return r.json(); }); }
  refreshCart().then(function () { if (document.body.classList.contains('tpl-cart')) open(cart); });

  /* ---------- gallery (PDP + quiz result) ---------- */
  function initGallery(gal) {
    if (!gal) return;
    var main = $('.main img', gal), th = $$('.thumbs .ph', gal), gi = 0, prev = $('.arr.prev', gal);
    if (prev) prev.hidden = true;
    function go(i) {
      if (!th.length) return;
      gi = (i + th.length) % th.length;
      if (prev) prev.hidden = gi === 0;
      th.forEach(function (x, j) { x.classList.toggle('on', j === gi); });
      /* video thumbs carry data-vsrc: play the clip over the main image instead of swapping the photo */
      var mv = $('.mainvid', gal), vs = th[gi].dataset.vsrc;
      if (vs && mv) {
        if (mv.getAttribute('src') !== vs) { mv.poster = th[gi].dataset.vposter || ''; mv.src = vs; }
        mv.hidden = false; mv.dataset.live = '1';
        /* keep the photo underneath until the clip has a frame to paint, so there is never a flash of empty background */
        var reveal = function () { if (!mv.hidden && main) main.style.visibility = 'hidden'; };
        if (mv.readyState >= 2) reveal(); else mv.addEventListener('loadeddata', reveal, { once: true });
        var pv = mv.play();
        /* a freshly set src can reject play() before it has data: retry once it can play */
        if (pv && pv.catch) pv.catch(function () { mv.addEventListener('canplay', function h() { mv.removeEventListener('canplay', h); var p2 = mv.play(); if (p2 && p2.catch) p2.catch(function () {}); }); });
        return;
      }
      if (mv && !mv.hidden) { mv.pause(); mv.hidden = true; delete mv.dataset.live; if (main) main.style.visibility = ''; }
      var s = th[gi].querySelector('img'); if (s && main) { main.src = s.currentSrc || s.src; main.srcset = s.srcset || ''; main.alt = s.alt; }
    }
    th.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    gal.addEventListener('click', function (e) { var a = e.target.closest('[data-gal]'); if (a) go(gi + (+a.dataset.gal)); });
    var sw = $('.swipe', gal), dots = $('.dots', gal);
    if (sw && dots && sw.children.length) {
      dots.innerHTML = new Array(sw.children.length + 1).join('<i></i>');
      var upd = function () { var w = sw.firstElementChild.offsetWidth + 10; var k = Math.round(sw.scrollLeft / w); $$('i', dots).forEach(function (x, j) { x.classList.toggle('on', j === k); }); };
      sw.addEventListener('scroll', upd, { passive: true }); upd();
    }
    /* swipe-gallery videos: iOS halts a swipe if a video starts playing mid-scroll and snaps back onto it,
       so only play the clip on the slide the swipe settles on, and pause the rest */
    var gvs = sw ? $$('video[data-gloop]', sw) : [];
    if (gvs.length) {
      var gt, inView = false;
      gvs.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
      var settle = function () {
        var w = sw.firstElementChild.offsetWidth + 10, k = Math.round(sw.scrollLeft / w);
        gvs.forEach(function (v) {
          var on = inView && v.closest('.ph') === sw.children[k];
          if (on) { v.dataset.live = '1'; if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } } else { delete v.dataset.live; if (!v.paused) v.pause(); }
        });
      };
      sw.addEventListener('scroll', function () { clearTimeout(gt); gt = setTimeout(settle, 120); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; settle(); }, { threshold: 0.4 }).observe(sw);
    }

    /* Warm the first gallery clip (it sits right after the hero, so nearly everyone reaches it) once the page
       has loaded. Without this the 1080p file only starts downloading on the tap/swipe and the shopper waits.
       iOS ignores preload, so a muted play-then-pause is what actually makes it buffer and paint frame one.
       Skipped on Save-Data, and never fired mid-swipe (starting a clip mid-scroll makes iOS snap back). */
    var touching = false;
    if (sw) {
      sw.addEventListener('touchstart', function () { touching = true; }, { passive: true });
      sw.addEventListener('touchend', function () { setTimeout(function () { touching = false; }, 400); }, { passive: true });
    }
    var shown = function (el) { return el && getComputedStyle(el).display !== 'none'; };
    var warm = function (v) {
      if (!v || v.dataset.warm || (navigator.connection && navigator.connection.saveData)) return;
      if (touching) { setTimeout(function () { warm(v); }, 600); return; }
      v.dataset.warm = '1'; v.muted = true; v.preload = 'auto';
      var p = v.play();
      if (p && p.then) p.then(function () { if (!v.dataset.live) { v.pause(); try { v.currentTime = 0; } catch (e) {} } }).catch(function () {});
    };
    var mv0 = $('.mainvid', gal), tv0 = $('.thumbs .tv', gal);
    if (mv0 && tv0 && !mv0.getAttribute('src')) {
      mv0.poster = tv0.dataset.vposter || ''; mv0.src = tv0.dataset.vsrc;
      if (tv0.dataset.vposter) (new Image()).src = tv0.dataset.vposter;
    }
    var warmUp = function () {
      setTimeout(function () {
        if (shown($('.thumbs', gal))) warm(mv0);
        else if (gvs.length && shown(sw)) warm(gvs[0]);
      }, 300);
    };
    if (document.readyState === 'complete') warmUp(); else window.addEventListener('load', warmUp, { once: true });
  }

  /* ---------- PDP ---------- */
  var pdp = $('[data-pdp]');
  /* Pre-order ship-by date: a fixed date from the section if one is set, otherwise today + N weeks,
     worked out in the browser so a cached page never shows yesterday's date. */
  var PRE_DATE = '';
  if (pdp) {
    var fx = (pdp.dataset.preFixed || '').trim(), pd = null;
    if (fx) PRE_DATE = fx;
    else { pd = new Date(); pd.setDate(pd.getDate() + (+pdp.dataset.preWeeks || 3) * 7); while (pd.getDay() === 0 || pd.getDay() === 6) pd.setDate(pd.getDate() + 1); PRE_DATE = pd.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
    $$('[data-pre-date]').forEach(function (el) { if (el !== pdp) el.textContent = PRE_DATE; });
    var PRE_SHORT = fx || pd.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    $$('[data-pre-short]').forEach(function (el) { el.textContent = PRE_SHORT; });
  }
  if (pdp) {
    var d = pdp.dataset;
    var SC = []; try { SC = JSON.parse(d.scents || '[]'); } catch (e) {}
    var TIERS = {
      one: { jars: 1, price: +d.price, was: +d.compare, name: d.scent, url: '' },
      two: { jars: 3, price: +d.b3Price, was: +d.b3Compare, name: 'Buy 2, Get 1 Free', url: d.b3Url || '' }
    };
    var cur = $('.tier.on', pdp) ? $('.tier.on', pdp).getAttribute('data-tier') : 'two';
    function scentByName(n) { for (var i = 0; i < SC.length; i++) if (SC[i].name === n) return SC[i]; return null; }
    /* jar rows: swap the thumbnail and the inspired-by line when a scent changes */
    $$('.jar select', pdp).forEach(function (s) {
      s.addEventListener('change', function () {
        var o = s.options[s.selectedIndex], jar = s.closest('.jar');
        /* image_tag emits a srcset, and srcset BEATS src - setting .src alone left the
           old scent's photo on screen. Drop the srcset before swapping the source. */
        var img = jar && jar.querySelector('img');
        if (img && o.dataset.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = o.dataset.img; }
        var ins = jar && jar.querySelector('[data-jar-insp]'); if (ins) ins.textContent = o.dataset.insp ? 'Inspired by ' + o.dataset.insp : '';
        var jst = jar && jar.querySelector('[data-jar-st]'); if (jst) jst.hidden = o.dataset.st !== 'pre';
        paint();
      });
    });
    $$('.tier', pdp).forEach(function (t) {
      t.addEventListener('click', function (e) { if (e.target.closest('select')) return; cur = t.getAttribute('data-tier'); $$('.tier', pdp).forEach(function (x) { x.classList.toggle('on', x === t); }); paint(); });
    });
    var subBox = $('[data-sub]', pdp), club = $('[data-club]', pdp), subPlan = $('[data-sub-plan]', pdp);
    var subPct = club && +club.dataset.pct ? +club.dataset.pct / 100 : 0.2;
    /* refills: each bundle option carries its own Appstle plan (Buy 1 = data-plan-one, Buy 2 Get 1 = data-plan-two).
       Swap the plan id, % and wording when the option changes; hide the box for an option with no plan. */
    function syncPlan() {
      if (!club || !subBox) return;
      var k = cur === 'one' ? 'One' : 'Two', id = club.dataset['plan' + k];
      club.hidden = !id;
      if (!id) { subBox.checked = false; club.classList.remove('on'); return; }
      var pct = +club.dataset['pct' + k] || 0, nm = club.dataset['name' + k] || '';
      subBox.value = id; subPct = pct / 100;
      var tt = $('[data-sub-title]', club), tx = $('[data-sub-text]', club);
      if (tt && club.dataset.titleTpl) tt.textContent = club.dataset.titleTpl.replace('[pct]', pct);
      if (tx && club.dataset.textTpl) tx.textContent = club.dataset.textTpl.replace('[plan]', nm);
    }
    if (subBox) subBox.addEventListener('change', function () { if (club) club.classList.toggle('on', subBox.checked); paint(); });
    if (subPlan && subBox) subPlan.addEventListener('change', function () { subBox.value = subPlan.value; });
    if (club && subBox && subBox.checked) club.classList.add('on');
    var atc = $('[data-atc]', pdp), atcLabel = $('[data-atc-label]', pdp) || atc, form = $('[data-product-form]', pdp);
    function stOf(name) { var sc = scentByName(name); return sc ? sc.st : ''; }
    /* does the basket the button would add contain a pre-order jar? */
    function hasPre() {
      var sels = $$('.tier.on .jar select', pdp);
      if (!sels.length) return d.state === 'pre';
      return sels.some(function (s) { var o = s.options[s.selectedIndex]; return (o && o.dataset.st || stOf(s.value)) === 'pre'; });
    }
    function paint() {
      syncPlan();
      var t = TIERS[cur], sub = subBox && subBox.checked && !subBox.disabled, p = sub ? Math.round(t.price * (1 - subPct) * 100) / 100 : t.price;
      var pre = hasPre();
      if (atc && !atc.disabled && atcLabel) atcLabel.textContent = (pre ? (d.preCta || 'Pre-order') + ' · ' : sub ? 'Subscribe · ' : 'Add to cart · ') + dollars(p);
      if (atc) atc.classList.toggle('pre', pre);
      var note = $('[data-pre-note]', pdp); if (note) note.hidden = !(pre && d.state !== 'pre');
      var pcta = $('[data-pbar-cta]'); if (pcta && atc && !atc.disabled) pcta.textContent = pre ? (d.preCta || 'Pre-order') : 'Add to cart';
      var row = $('[data-price-row]', pdp);
      if (row) { var b = row.querySelector('b'), s = row.querySelector('s'), o = row.querySelector('.off'); if (b) b.textContent = dollars(p); if (s) s.textContent = dollars(t.was); if (o) o.textContent = 'Save ' + dollars(t.was - p); }
      var sw = $('[data-st-was]', pdp), sp = $('[data-st-price]', pdp), ss = $('[data-st-save]', pdp);
      if (sw) sw.textContent = dollars(t.was); if (sp) sp.textContent = dollars(p); if (ss) ss.textContent = 'You’re saving ' + dollars(t.was - p);
      var bt = $('[data-pbar-title]'), bs = $('[data-pbar-sub]');
      if (bt) bt.textContent = t.name + ' · ' + dollars(p); if (bs) bs.textContent = t.jars > 1 ? t.jars + ' jars · mix any scents' : (d.weight || '');
    }
    paint();
    /* ?trio=1 (gift links): open on Buy 2, Get 1 Free with one jar of each scent already picked */
    if (/[?&]trio=1\b/.test(location.search)) {
      var t2 = $('.tier[data-tier="two"]', pdp);
      if (t2) {
        $$('.jar select', t2).forEach(function (s, i) { if (SC[i]) { s.value = SC[i].name; s.dispatchEvent(new Event('change')); } });
        cur = 'two'; $$('.tier', pdp).forEach(function (x) { x.classList.toggle('on', x === t2); }); paint();
      }
    }
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = TIERS[cur];
      if (t.jars > 1 && t.url) { location.href = t.url; return; }   /* a bundle app product handles the mix */
      var base = +$('input[name="id"]', form).value, counts = {}, order = [];
      var preIds = {};
      $$('.tier.on .jar select', pdp).forEach(function (s) { var sc = scentByName(s.value), o = s.options[s.selectedIndex]; var id = sc && sc.id ? sc.id : base; if (((o && o.dataset.st) || (sc && sc.st)) === 'pre') preIds[id] = 1; if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
      if (!order.length) { order.push(base); counts[base] = t.jars; if (d.state === 'pre') preIds[base] = 1; }
      var items = order.map(function (id) {
        var it = { id: id, quantity: counts[id] };
        if (t.jars > 1) it.properties = { 'Bundle': t.name, '_bundle': cur };
        if (preIds[id]) { it.properties = it.properties || {}; it.properties['Pre-order'] = 'Ships by ' + PRE_DATE; }
        if (subBox && subBox.checked && !subBox.disabled && +subBox.value) it.selling_plan = +subBox.value;
        return it;
      });
      atc.classList.add('busy');
      add({ items: items }).then(function () { atc.classList.remove('busy'); toast('Added to cart'); return refreshCart(); }).then(function () { open(cart); })
        .catch(function (r) { atc.classList.remove('busy'); (r && r.json ? r.json() : Promise.resolve({})).then(function (j) { toast((j && j.description) || 'Could not add to cart'); }); });
    });
    var pc = $('[data-pbar-cta]'); if (pc) { pc.textContent = atc && atc.disabled ? 'Sold out' : hasPre() ? (d.preCta || 'Pre-order') : 'Add to cart'; pc.addEventListener('click', function (e) { e.preventDefault(); atc && atc.click(); }); }
    initGallery($('#pdpGal'));
  }

  /* ---------- scarcity meter ----------
     Deterministic per (hour, product): the same visitor reloading five times in a row sees
     the same number, and all three scents do not show an identical figure. A plain random()
     would re-roll on every paint and read as obviously fake. */
  $$('[data-stockbar]').forEach(function (el) {
    var min = +el.dataset.min || 85, max = +el.dataset.max || 96, seed = +el.dataset.seed || 0;
    if (max < min) { var t = min; min = max; max = t; }
    var h = Math.floor(Date.now() / 36e5) + seed;
    var x = Math.sin(h * 12.9898) * 43758.5453; x -= Math.floor(x);
    var pct = min + Math.floor(x * (max - min + 1));
    var p = $('[data-sb-pct]', el), f = $('[data-sb-fill]', el);
    if (p) p.textContent = pct + '%';
    el.hidden = false;
    if (f) requestAnimationFrame(function () { f.style.width = pct + '%'; });
  });

  /* ---------- sold-out waitlist ---------- */
  $$('[data-bis]').forEach(function (box) {
    var form = $('form', box), msg = $('[data-bis-msg]', box);
    if (!form) return;
    function say(t, bad) { if (!msg) return; msg.textContent = t; msg.hidden = false; msg.classList.toggle('bad', !!bad); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input[type="email"]', form), email = (input.value || '').trim(), btn = $('button', form);
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { say('That email does not look right.', true); input.focus(); return; }
      btn.disabled = true; btn.classList.add('busy'); say('Adding you…');
      var scent = box.dataset.scent || '';
      klSubscribe(email, KL.bisList, 'PDP restock waitlist')
        .then(function () { return klEvent(email, 'Back in Stock Requested', { Scent: scent, 'Variant ID': box.dataset.variant || '', URL: location.href }); })
        .then(function () { form.hidden = true; say('You are on the list. We will email you the moment ' + (scent || 'it') + ' is back.'); })
        .catch(function () { btn.disabled = false; btn.classList.remove('busy'); say('Could not save that. Try again in a moment.', true); });
    });
  });

  /* ---------- email sign-ups (drip Club section, footer): straight onto their own Klaviyo lists ---------- */
  $$('form[data-club]').forEach(function (form) {
    var list = form.dataset.list, msg = $('[data-club-msg]', form);
    if (!list || !KL.key) return; /* no list set: let the Shopify customer form submit as normal */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input[type="email"]', form), email = (input.value || '').trim(), btn = $('button[type="submit"]', form);
      var say = function (t) { if (msg) { msg.textContent = t; msg.hidden = !t; } };
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { say('That email does not look right.'); input.focus(); return; }
      say(''); btn.disabled = true; btn.classList.add('busy');
      klSubscribe(email, list, form.dataset.source || 'drip Club')
        .then(function () {
          form.innerHTML = '<p class="club2-ok" role="status"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></p>';
          $('.club2-ok', form).appendChild(document.createTextNode(form.dataset.ok || "You're in. Welcome to the drip Club."));
        })
        .catch(function () { btn.disabled = false; btn.classList.remove('busy'); say('Could not save that. Try again in a moment.'); });
    });
  });

  /* ---------- PDP video row: play only what is on screen, tap for sound ---------- */
  $$('[data-vids]').forEach(function (row) {
    var vids = $$('video', row);
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); if (!v.muted) { v.muted = true; v.closest('.v').classList.remove('unmuted'); } }
        });
      }, { threshold: 0.35, rootMargin: '300px 0px' });  /* preload="none" means nothing is fetched until play(), so start a little early */
      vids.forEach(function (v) { io.observe(v); });
    }
    $$('[data-snd]', row).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var wrap = b.closest('.v'), v = $('video', wrap), turnOn = v.muted;
        vids.forEach(function (o) { o.muted = true; o.closest('.v').classList.remove('unmuted'); });
        if (turnOn) { v.muted = false; wrap.classList.add('unmuted'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    /* arrows for mouse users once the row holds more clips than fit */
    var box = row.closest('.vids-wrap'), prev = box && $('[data-vids-prev]', box), next = box && $('[data-vids-next]', box);
    if (prev && next) {
      var sync = function () {
        var max = row.scrollWidth - row.clientWidth;
        box.classList.toggle('can-scroll', max > 4);
        prev.disabled = row.scrollLeft < 4;
        next.disabled = row.scrollLeft > max - 4;
      };
      var step = function (dir) { row.scrollBy({ left: dir * row.clientWidth * 0.9, behavior: 'smooth' }); };
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  });

  /* ---------- muted loops (hero alt, pillars, PDP gallery videos): play only while on screen ---------- */
  var loops = $$('video[data-loop]');
  if (loops.length && 'IntersectionObserver' in window) {
    var lio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: 0.25, rootMargin: '200px 0px' });
    loops.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); lio.observe(v); });
  }

  /* ---------- ships-by (next business day) ---------- */
  $$('[data-shipsby]').forEach(function (el) {
    var dt = new Date(); dt.setDate(dt.getDate() + 1);
    while (dt.getDay() === 0 || dt.getDay() === 6) dt.setDate(dt.getDate() + 1);
    el.textContent = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dt.getDay()];
  });

  /* ---------- header: tucks away while scrolling down, slides back on any scroll up ---------- */
  (function () {
    var root = document.documentElement, last = window.pageYOffset, busy = false;
    function upd() {
      var y = window.pageYOffset, d = y - last;
      if (y < 120) root.classList.remove('hdr-away');
      else if (d > 6) root.classList.add('hdr-away');
      else if (d < -6) root.classList.remove('hdr-away');
      if (Math.abs(d) > 6 || y < 120) last = y;
      busy = false;
    }
    window.addEventListener('scroll', function () { if (!busy) { busy = true; requestAnimationFrame(upd); } }, { passive: true });
  })();

  /* ---------- sticky bar: product pages only, and only once the hero add-to-cart has scrolled up past
     the top of the screen (not while it is still below, before the shopper has reached it) ---------- */
  var bar = $('[data-pbar]'), watch = $('[data-atc]');
  if (bar && watch && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { var x = e[0]; bar.classList.toggle('show', !x.isIntersecting && x.boundingClientRect.bottom < 0); }, { threshold: 0 }).observe(watch);
  }

  /* ---------- countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  $$('[data-cd]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-end') || cfg.offerEnd || 0);
    function tick() {
      var dd = end - Date.now();
      if (!(dd > 0)) { el.innerHTML = '<span>Buy 2, Get 1 Free</span><span>Buy 3, Get 2 Free</span>'; if (el.previousElementSibling) el.previousElementSibling.textContent = 'Launch offer'; return; }
      var days = Math.floor(dd / 864e5), h = Math.floor(dd % 864e5 / 36e5), m = Math.floor(dd % 36e5 / 6e4), s = Math.floor(dd % 6e4 / 1e3);
      el.innerHTML = (days ? '<span>' + days + '<small>DAYS</small></span>' : '') + '<span>' + pad(h) + '<small>HRS</small></span><span>' + pad(m) + '<small>MIN</small></span><span>' + pad(s) + '<small>SEC</small></span>';
      setTimeout(tick, 1000);
    }
    tick();
  });

  /* ---------- review wall masonry ---------- */
  function layoutWalls() {
    $$('[data-wall]').forEach(function (w) {
      if (!w.__cards) w.__cards = $$('.rev', w);
      var n = getComputedStyle(w).gridTemplateColumns.split(' ').length;
      w.style.minHeight = w.offsetHeight + 'px';  /* hold the page height while the cards are re-dealt, so the scroll position cannot jump */
      w.innerHTML = ''; var cols = [];
      for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'col'; w.appendChild(c); cols.push(c); }
      var isOpen = w.classList.contains('open');
      w.__cards.forEach(function (card) { if (card.classList.contains('more') && !isOpen) return; var best = cols[0]; cols.forEach(function (c) { if (c.offsetHeight < best.offsetHeight) best = c; }); best.appendChild(card); });
      w.style.minHeight = '';
    });
  }
  /* phones fire resize when the address bar slides in or out (height only): re-deal the wall only when the width changes */
  var rt, lastW = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; clearTimeout(rt); rt = setTimeout(layoutWalls, 120); });
  window.addEventListener('load', layoutWalls); layoutWalls();
  document.addEventListener('click', function (e) {
    var sm = e.target.closest('[data-showmore]');
    if (sm) { var w = sm.closest('section').querySelector('[data-wall]'); if (w) { w.classList.add('open'); sm.style.display = 'none'; layoutWalls(); } }
    var a = e.target.closest('[data-slide]');
    if (a) { var s = a.closest('.slider-wrap').querySelector('[data-slider]'); if (s && s.firstElementChild) s.scrollBy({ left: (+a.dataset.slide) * (s.firstElementChild.getBoundingClientRect().width + 26), behavior: 'smooth' }); }
  });
  document.addEventListener('shopify:section:load', layoutWalls);

  /* ---------- quiz ---------- */
  var q = $('[data-quiz]');
  if (q) {
    var Q = [], R = {};
    try { Q = JSON.parse(q.getAttribute('data-questions') || '[]'); R = JSON.parse(q.getAttribute('data-results') || '{}'); } catch (e) { Q = []; }
    var qi = 0, score = {}, answers = [], card = $('.qcard', q), prog = $('.qprog', q), progI = $('.qprog i', q);
    /* "Who's it for?" - women buying for a partner get his-match copy and are tagged as gifters.
       ?for=him (from the gift page) answers it up front and skips the step. */
    var whoOn = q.dataset.who === 'true', forHim = /[?&]for=him\b/i.test(location.search), whoPreset = forHim;
    var BACK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
    function backBtn() { return '<button type="button" class="qback" data-back>' + BACK_SVG + 'Back</button>'; }
    /* Step back one question and undo that answer's weights, so the score stays honest. */
    function goBack() {
      if (qi <= 0) { qi = 0; answers.length = 0; return (whoOn && !whoPreset) ? whoStep() : intro(); }
      qi--;
      var w = answers[qi] || {};
      for (var k in w) score[k] = (score[k] || 0) - w[k];
      answers.length = qi;
      render();
    }
    function wireBack() { var b = $('[data-back]', card); if (b) b.addEventListener('click', goBack); }
    var steps = Q.length + (q.dataset.emailOn === 'true' ? 2 : 1) + (whoOn && !whoPreset ? 1 : 0), off = whoOn && !whoPreset ? 1 : 0;
    function whoStep() {
      setProg(0); answers.length = 0; resetScore(); qi = 0;
      card.innerHTML = '<div class="qbody qwho">' + backBtn() + '<span class="qmatch">' + esc(q.dataset.whoKicker || 'First things first') + '</span><h2 class="qq">' + esc(q.dataset.whoQ || 'Who\u2019s it for?') + '</h2><div class="opts">' +
        '<button type="button" class="opt" data-who="me"><span>' + esc(q.dataset.whoMe || 'Me') + (q.dataset.whoMeSub ? '<small>' + esc(q.dataset.whoMeSub) + '</small>' : '') + '</span></button>' +
        '<button type="button" class="opt" data-who="him"><span>' + esc(q.dataset.whoHim || 'Him, it\u2019s a gift') + (q.dataset.whoHimSub ? '<small>' + esc(q.dataset.whoHimSub) + '</small>' : '') + '</span></button></div></div>';
      $$('[data-who]', card).forEach(function (b) { b.addEventListener('click', function () { forHim = b.getAttribute('data-who') === 'him'; render(); }); });
      var bb = $('[data-back]', card); if (bb) bb.addEventListener('click', intro);
      focusCard();
    }
    function resetScore() { score = {}; answers = []; Object.keys(R).forEach(function (k) { score[k] = 0; }); }
    function best() { return Object.keys(score).sort(function (a, b) { return score[b] - score[a]; })[0]; }
    function focusCard() { var r = card.getBoundingClientRect(); if (r.top < 60) window.scrollTo({ top: window.scrollY + r.top - 90, behavior: 'smooth' }); }
    function setProg(p) { if (progI) progI.style.width = p + '%'; }
    function intro() {
      q.classList.remove('wide'); if (prog) prog.hidden = true; resetScore();
      var img = Q[0] && Q[0].img;
      card.innerHTML = '<div class="qintro">' + (img ? '<div class="qimg tall"><img src="' + img + '" alt=""></div>' : '') +
        '<div class="qbody center"><span class="qmatch">' + esc(q.dataset.kicker || '30-second scent quiz') + '</span><h1 class="qtitle">' + ((whoPreset && q.dataset.headingHim) || q.dataset.heading || 'Which drip are you?') + '</h1>' +
        (((whoPreset && q.dataset.leadHim) || q.dataset.lead) ? '<p class="lead" style="margin:12px auto 0">' + esc((whoPreset && q.dataset.leadHim) || q.dataset.lead) + '</p>' : '') +
        '<div class="cta-wrap"><button type="button" class="cta dark" data-start>' + esc(q.dataset.startLabel || 'Start the quiz') + '</button><span class="guar">' + Q.length + ' questions · 30 seconds</span></div></div></div>';
      $('[data-start]', card).addEventListener('click', function () { qi = 0; resetScore(); if (prog) prog.hidden = false; if (whoOn && !whoPreset) whoStep(); else render(); });
    }
    function render() {
      var it = Q[qi]; setProg((qi + off) / steps * 100);
      card.innerHTML = '<div class="qimg">' + (it.img ? '<img src="' + it.img + '" alt="">' : '') + '<span class="qnum">Question ' + (qi + 1) + ' of ' + Q.length + '</span></div>' +
        '<div class="qbody">' + backBtn() + '<h2 class="qq">' + esc(forHim && it.qh ? it.qh : it.q) + '</h2><div class="opts">' + it.o.map(function (o, j) {
          return '<button type="button" class="opt" data-j="' + j + '">' + (o[3] ? '<span class="em" aria-hidden="true">' + o[3] + '</span>' : '') + '<span>' + esc(o[0]) + (o[1] ? '<small>' + esc(o[1]) + '</small>' : '') + '</span></button>';
        }).join('') + '</div></div>';
      $$('.opt', card).forEach(function (b) {
        b.addEventListener('click', function () {
          var w = it.o[+b.getAttribute('data-j')][2] || {}; answers[qi] = w; for (var k in w) score[k] = (score[k] || 0) + w[k];
          qi++; if (qi < Q.length) render(); else if (q.dataset.emailOn === 'true') emailStep(); else loading();
        });
      });
      wireBack();
      focusCard();
    }
    function emailStep() {
      setProg((Q.length + off) / steps * 100);
      card.innerHTML = '<div class="qemail">' + backBtn() + '<span class="qmatch">One last thing</span><h2 class="qq" style="margin:0">' + esc(forHim ? (q.dataset.emailHeadingHim || 'Where should we send his match?') : (q.dataset.emailHeading || 'Where should we send your match?')) + '</h2><p class="lead" style="margin:10px auto 0;max-width:460px">' + esc(q.dataset.emailText || '') + '</p>' +
        '<form class="email" data-qemail><input type="email" name="email" placeholder="Email address" aria-label="Email address" required><button type="submit">Show me</button></form><button type="button" class="skip" data-skip>Skip, just show my match</button></div>';
      $('[data-qemail]', card).addEventListener('submit', function (e) {
        e.preventDefault();
        var qEmail = $('input', this).value, qMatch = best();
        var fd = new FormData(); fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', qEmail); fd.append('contact[tags]', 'quiz,quiz-' + qMatch + (forHim ? ',quiz-gift' : ''));
        try { fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {}); } catch (err) {}
        /* Shopify gets the customer record, Klaviyo gets the marketing consent and the match.
           Both are fire-and-forget: the quiz must never stall on a third party. */
        try {
          var r = R[qMatch] || {};
          klSubscribe(qEmail, KL.quizList, 'Scent quiz')
            .then(function () { return klEvent(qEmail, 'Scent Quiz Completed', { Match: r.name || qMatch, 'Inspired By': r.insp || '', For: forHim ? 'Him' : 'Me', URL: location.href }); })
            .catch(function () {});
        } catch (err2) {}
        loading();
      });
      $('[data-skip]', card).addEventListener('click', loading);
      wireBack();
      focusCard();
    }
    function loading() {
      setProg(96);
      card.innerHTML = '<div class="qload"><div class="spin" aria-hidden="true"></div><p>' + esc(q.dataset.loadingText || 'Finding your match…') + '</p><small>Matching your answers to three scents</small></div>';
      focusCard();
      setTimeout(result, 2600);
    }
    function result() {
      setProg(100); q.classList.add('wide');
      var r = R[best()] || R[Object.keys(R)[0]]; if (!r) return;
      var imgs = (r.imgs && r.imgs.length) ? r.imgs : [r.img];
      var trust = (q.dataset.trust || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      card.innerHTML = '<div class="qres"><div class="qgal"><div class="gal" data-qgal>' +
        '<div class="ph main"><img src="' + imgs[0] + '" alt="' + esc(r.name) + '"><button type="button" class="arr prev" data-gal="-1" aria-label="Previous image">' + ARR_L + '</button><button type="button" class="arr next" data-gal="1" aria-label="Next image">' + ARR_R + '</button></div>' +
        '<div class="swipe">' + imgs.map(function (u) { return '<div class="ph"><img src="' + u + '" alt=""></div>'; }).join('') + '</div><div class="dots" aria-hidden="true"></div>' +
        '<div class="thumbs">' + imgs.map(function (u, k) { return '<div class="ph' + (k ? '' : ' on') + '"><img src="' + u + '" alt=""></div>'; }).join('') + '</div></div></div>' +
        '<div class="qtxt"><span class="qmatch">' + (forHim ? 'His match' : 'Your match') + '</span><h2 class="qname"><span class="sw" style="background:' + esc(r.swatch) + '"></span>' + esc(r.name) + '</h2>' +
        (r.notes ? '<p class="script qnotes">' + esc(r.notes) + '</p>' : '') +
        '<p class="qwhy">' + esc(r.why) + (r.insp ? ' Inspired by ' + esc(r.insp) + '.' : '') + '</p>' +
        (trust.length ? '<ul class="qtrust">' + trust.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' : '') +
        '<a class="cta dark" href="' + r.url + '">' + (forHim ? 'Gift him ' : 'Get ') + esc(r.name) + (r.price ? ' · ' + money(r.price) : '') + '</a>' +
        ((forHim ? q.dataset.bundleNoteHim : q.dataset.bundleNote) ? '<p class="qalt">' + esc(forHim ? q.dataset.bundleNoteHim : q.dataset.bundleNote) + (q.dataset.shop ? ' <a href="' + q.dataset.shop + '">See all three</a>' : '') + '</p>' : '') +
        '<button type="button" class="skip" data-retake>' + (forHim ? 'Not quite him?' : 'Not you?') + ' Retake the quiz</button></div></div>';
      initGallery($('[data-qgal]', card));
      $('[data-retake]', card).addEventListener('click', function () { whoPreset = /[?&]for=him\b/i.test(location.search); forHim = whoPreset; intro(); });
      focusCard();
    }
    if (Q.length) intro();
  }
  /* ---------- sign-up pop-up: ball drop -> email -> (sms) -> done ----------
     The prize is drawn from the slot weights first. The board is a real physics simulation
     (gravity, ball-peg collisions); before the drop we simulate candidate drops and replay one
     that physically lands in the drawn slot, so what the visitor sees is exactly what they
     won and the ball genuinely strikes the pegs on the way down. Only the
     prize type (fifteen / shipping / mystery) is stored on the Klaviyo profile; the
     "Pop-up welcome" flow emails the matching code. */
  var pop = $('[data-drip-pop]');
  if (pop) (function () {
    var KEY = 'drip_pop_v1', ROWS = 8;
    var preview = pop.dataset.preview === 'true';
    function rd() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
    function wr(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    var st = rd() || {}, phone = matchMedia('(max-width:900px)').matches;
    var snoozed = st.closed && (Date.now() - st.closed) < (+pop.dataset.days || 7) * 864e5;
    var offPage = (phone && pop.dataset.mobile !== 'true') ||
      /[?&](utm_source=klaviyo|utm_medium=email)/.test(location.search) || /^\/(cart|account|checkouts?)/.test(location.pathname);
    var blocked = !preview && (st.done || snoozed || offPage);
    /* reopen pill: peeks in bottom-left after a visitor closes the pop-up without signing up, so an
       accidental x is not the end of it. Its own x hides it for the same number of days. */
    var teaser = $('[data-pop-teaser]');
    function showTeaser() {
      var t = rd() || {};
      if (!teaser || pop.dataset.teaser !== 'true' || t.done || isOpen || offPage) return;
      if (t.pillOff && (Date.now() - t.pillOff) < (+pop.dataset.days || 7) * 864e5) return;
      teaser.hidden = false;
    }
    var board = $('[data-board]', pop), cv = $('[data-pegs]', pop), ctx = cv.getContext && cv.getContext('2d'), bins = $$('[data-bin]', pop);
    var isOpen = false, played = false, prize = null, lastFocus = null;

    function step(name) {
      $$('[data-step]', pop).forEach(function (el) { el.hidden = el.dataset.step !== name; });
      var f = $('[data-step="' + name + '"] input, [data-step="' + name + '"] .dpop-btn', pop); if (f && name !== 'play') f.focus();
    }
    /* ---- board geometry + physics ---- */
    var B = null, anim = null, mode = 'idle', path = null, glows = [], trail = [];
    function build() {
      var W = board.clientWidth, H = board.clientHeight - 56, top = 14, dx = W / 10, dy = (H - top - 18) / (ROWS - 1), pegs = [];
      for (var r = 0; r < ROWS; r++) for (var i = 0; i < r + 2; i++) pegs.push({ x: W / 2 + (i - (r + 1) / 2) * dx, y: top + r * dy });
      B = { W: W, H: H, full: board.clientHeight, top: top, dx: dx, dy: dy, pegs: pegs, pr: Math.max(2.6, dx * 0.08), br: Math.max(5, dx * 0.16), exitY: top + (ROWS - 1) * dy + dy * 0.55 };
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr); cv.height = Math.round(B.full * dpr); cv.style.width = W + 'px'; cv.style.height = B.full + 'px';
      if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function rng(seed) { return function () { seed = (seed * 1664525 + 1013904223) % 4294967296; return seed / 4294967296; }; }
    function simulate(rnd, steer, target) {
      var b = B, g = b.H * 1.25, dt = 1 / 240, e = 0.42 + rnd() * 0.12, R = b.br + b.pr, binW = b.W / 5;
      var x = b.W / 2 + (rnd() - 0.5) * 2, y = b.br + 3, vx = (rnd() - 0.5) * b.dx * 0.9, vy = 0   /* starts where the ball rests */, frames = [], hits = [], last = {};
      for (var n = 0; n < 240 * 12; n++) {
        vy += g * dt;
        if (steer) { var k = Math.max(0, (y - b.H * 0.35) / b.H); vx += ((target + 0.5) * binW - x) * steer * k * dt; }
        vx *= 0.9995; x += vx * dt; y += vy * dt;
        for (var p = 0; p < b.pegs.length; p++) {
          var pg = b.pegs[p], ex = x - pg.x, ey = y - pg.y, d2 = ex * ex + ey * ey;
          if (d2 < R * R) {
            var d = Math.sqrt(d2) || 0.01, nx = ex / d, ny = ey / d;
            if (Math.abs(nx) < 0.08) { nx = (rnd() < 0.5 ? -1 : 1) * 0.08; ny = -Math.sqrt(1 - nx * nx); }   /* never balance on a peg */
            x = pg.x + nx * R; y = pg.y + ny * R;
            var vn = vx * nx + vy * ny;
            if (vn < 0) { vx -= (1 + e) * vn * nx; vy -= (1 + e) * vn * ny; vx *= 0.96; if (!last[p] || n - last[p] > 30) hits.push([frames.length, p]); last[p] = n; }
          }
        }
        if (x < b.br) { x = b.br; vx = Math.abs(vx) * e; } if (x > b.W - b.br) { x = b.W - b.br; vx = -Math.abs(vx) * e; }
        if (n % 4 === 0) frames.push([x, y]);
        if (y > b.exitY) break;
      }
      return { frames: frames, hits: hits, bin: Math.min(4, Math.max(0, Math.floor(x / binW))) };
    }
    function plan(target) {
      var seed = Math.floor(Math.random() * 1e9), best = null;
      for (var steer = 0; steer <= 6; steer += 1.5)
        for (var n = 0; n < (steer ? 150 : 600); n++) {
          var r = simulate(rng(seed + n * 7919 + steer * 31), steer, target);
          if (r.bin === target) { if (r.hits.length >= 5) return r; best = best || r; }
        }
      return best || simulate(rng(seed), 6, target);
    }
    function draw(now) {
      if (!ctx || !B) return;
      var b = B; ctx.clearRect(0, 0, b.W, b.full);
      glows = glows.filter(function (gl) { return now - gl.t < 420; });
      for (var p = 0; p < b.pegs.length; p++) {
        var pg = b.pegs[p], hot = null;
        for (var q = 0; q < glows.length; q++) if (glows[q].p === p) hot = glows[q];
        if (hot) {
          var a = (now - hot.t) / 420;
          ctx.beginPath(); ctx.arc(pg.x, pg.y, b.pr + a * b.pr * 3.2, 0, 6.2832); ctx.strokeStyle = 'rgba(201,161,90,' + (0.75 * (1 - a)).toFixed(3) + ')'; ctx.lineWidth = 1.6; ctx.stroke();
        }
        ctx.beginPath(); ctx.arc(pg.x, pg.y, hot ? b.pr * 1.35 : b.pr, 0, 6.2832);
        ctx.fillStyle = hot && now - hot.t < 220 ? '#B58A3A' : '#171412'; ctx.fill();
      }
      for (var t = 0; t < trail.length; t++) {
        var tr = trail[t], al = (t + 1) / (trail.length + 1) * 0.28 * (tr[2] == null ? 1 : tr[2]);
        ctx.beginPath(); ctx.arc(tr[0], tr[1], b.br * (0.55 + 0.45 * (t + 1) / trail.length), 0, 6.2832); ctx.fillStyle = 'rgba(181,138,58,' + al.toFixed(3) + ')'; ctx.fill();
      }
      if (ball) {
        ctx.save(); ctx.globalAlpha = ball[2] == null ? 1 : ball[2];
        ctx.shadowColor = 'rgba(23,20,18,.28)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 2;
        var gr = ctx.createRadialGradient(ball[0] - b.br * 0.35, ball[1] - b.br * 0.4, b.br * 0.1, ball[0], ball[1], b.br);
        gr.addColorStop(0, '#F6E2A6'); gr.addColorStop(0.55, '#C9A15A'); gr.addColorStop(1, '#7A5A20');
        ctx.beginPath(); ctx.arc(ball[0], ball[1], b.br, 0, 6.2832); ctx.fillStyle = gr; ctx.fill(); ctx.restore();
      }
    }
    var ball = null;
    function loop(now) {
      if (!isOpen) { anim = null; return; }
      if (mode === 'idle' && B) { ball = [B.W / 2, B.br + 3]; trail = []; }   /* resting, centred, until dropped */
      draw(now);
      anim = requestAnimationFrame(loop);
    }
    function drawPegs() { build(); if (!anim) anim = requestAnimationFrame(loop); }
    var xt;
    function open() {
      if (isOpen) return; isOpen = true; lastFocus = document.activeElement;
      if (teaser) teaser.hidden = true;
      pop.hidden = false; document.documentElement.style.overflow = 'hidden';
      drawPegs(); setTimeout(function () { pop.classList.add('on'); }, 20);
      /* focus the dialog itself (not the x, which drew a focus box on open), and hold the x back briefly */
      try { pop.focus({ preventScroll: true }); } catch (e) { pop.focus(); }
      var xd = Math.max(0, +pop.dataset.xDelay || 0) * 1000;
      clearTimeout(xt);
      if (xd) { pop.classList.add('x-wait'); xt = setTimeout(function () { pop.classList.remove('x-wait'); }, xd); }
    }
    function close() {
      if (!isOpen) return; isOpen = false;
      var was = rd() || {};
      if (!was.done) { was.closed = Date.now(); wr(was); }
      pop.classList.remove('on'); document.documentElement.style.overflow = '';
      setTimeout(function () { pop.hidden = true; showTeaser(); }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function pick() {
      var w = bins.map(function (b) { return Math.max(1, +b.dataset.weight || 1); });
      var t = Math.random() * w.reduce(function (a, b) { return a + b; }, 0);
      for (var i = 0; i < w.length; i++) { if ((t -= w[i]) < 0) return i; }
      return w.length - 1;
    }
    function drop() {
      if (prize) { step('email'); return; }   /* second press = "Claim my prize" */
      if (played || !B) return; played = true;
      var btn = $('[data-drop]', pop); btn.disabled = true; btn.textContent = 'Dropping…';
      var target = pick(), r = plan(target), hitAt = {}, start = null, endX = (target + 0.5) * B.W / 5;
      r.hits.forEach(function (h) { (hitAt[h[0]] = hitAt[h[0]] || []).push(h[1]); });
      var lastF = -1, fall = null;
      mode = 'drop';
      function step2(now) {
        if (start === null) start = now;
        var f = Math.floor((now - start) / 1000 * 60);
        if (f < r.frames.length) {
          for (var k = lastF + 1; k <= f; k++) if (hitAt[k]) hitAt[k].forEach(function (p) { glows.push({ p: p, t: now }); });
          lastF = f; ball = r.frames[f].slice(); trail.push(ball.slice()); if (trail.length > 7) trail.shift();
          return requestAnimationFrame(step2);
        }
        /* roll into the slot and drop out of sight */
        if (fall === null) fall = { t: now, x: ball[0], y: ball[1] };
        var u = Math.min(1, (now - fall.t) / 520), ez = 1 - Math.pow(1 - u, 3);
        ball = [fall.x + (endX - fall.x) * ez, fall.y + (B.H + 30 - fall.y) * u * u, 1 - Math.max(0, (u - 0.55) / 0.45)];
        trail.push(ball.slice()); if (trail.length > 7) trail.shift();
        if (u < 1) return requestAnimationFrame(step2);
        ball = null; trail = []; mode = 'done'; win(target);
      }
      requestAnimationFrame(step2);
    }
    function win(i) {
      var b = bins[i]; b.classList.add('win');
      prize = { type: b.dataset.prize || 'mystery', label: b.dataset.label || '' };
      $('[data-prize-text]', pop).textContent = prize.type === 'mystery' ? 'a mystery discount.' : prize.label + '.';
      if (prize.type === 'mystery') { var n = $('[data-prize-note]', pop); n.textContent = 'Enter your email and we\'ll reveal it in your inbox. Works with Buy 2, Get 1 Free.'; }
      /* stay on the board: show what they landed on and let them move on when ready */
      var res = $('[data-result]', pop);
      if (res) { res.innerHTML = 'You landed on <b>' + esc(b.dataset.label || '') + '</b>'; res.hidden = false; }
      var btn = $('[data-drop]', pop);
      setTimeout(function () { btn.textContent = 'Claim my prize'; btn.disabled = false; btn.classList.add('ready'); btn.focus(); }, 500);
    }
    function err(form, on) { var e = $('[data-err]', form); if (e) e.hidden = !on; }
    $('[data-email-form]', pop).addEventListener('submit', function (e) {
      e.preventDefault();
      var form = this, email = $('input', form).value.trim(), btn = $('button', form);
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { err(form, true); return; }
      err(form, false); btn.disabled = true; pop.dataset.email = email;
      var props = { popup_prize: prize ? prize.type : 'mystery', popup_prize_label: prize ? prize.label : '', popup_signup_url: location.href };
      klFetch('profiles', { data: { type: 'profile', attributes: { email: email, properties: props } } })
        .catch(function () {})
        .then(function () { return klSubscribe(email, pop.dataset.list || KL.popupList, 'Pop-up ball drop'); })
        .then(function () {
          wr({ done: 1 });
          try { klEvent(email, 'Pop-up Prize Won', { Prize: props.popup_prize, 'Prize Label': props.popup_prize_label }).catch(function () {}); } catch (x) {}
          step(pop.dataset.sms === 'true' ? 'sms' : 'done');
        })
        .catch(function () { btn.disabled = false; var el = $('[data-err]', form); el.textContent = 'Something went wrong. Please try again.'; el.hidden = false; });
    });
    var smsForm = $('[data-sms-form]', pop);
    if (smsForm) smsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = $('input', this).value.replace(/\D/g, ''), btn = $('button', this), form = this;
      if (d.length === 10) d = '1' + d;
      if (!/^1\d{10}$/.test(d)) { err(form, true); return; }
      err(form, false); btn.disabled = true;
      klFetch('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Pop-up ball drop (SMS)',
        profile: { data: { type: 'profile', attributes: { email: pop.dataset.email, phone_number: '+' + d,
          subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: pop.dataset.list || KL.popupList } } } } })
        .then(function () { step('done'); })
        .catch(function () { btn.disabled = false; var el = $('[data-err]', form); el.textContent = 'Something went wrong. Please try again.'; el.hidden = false; });
    });
    $$('[data-sms-skip]', pop).forEach(function (b) { b.addEventListener('click', function () { step('done'); }); });
    $('[data-drop]', pop).addEventListener('click', drop);
    $$('[data-pop-close], [data-pop-close-link]', pop).forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = $$('button:not([disabled]), a[href], input', pop).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    window.addEventListener('resize', function () { if (isOpen && !played) build(); });
    $$('[data-open-pop]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(pop)) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(pop)) close(); });
    if (teaser) {
      $('[data-pop-teaser-open]', teaser).addEventListener('click', open);
      $('[data-pop-teaser-x]', teaser).addEventListener('click', function () { var t = rd() || {}; t.pillOff = Date.now(); wr(t); teaser.hidden = true; });
    }
    if (blocked) { if (snoozed && !st.done) showTeaser(); return; }
    setTimeout(open, (+pop.dataset.delay || 0) * 1000);
    if (pop.dataset.exit === 'true' && !phone) document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
    });
  })();
})();
